import React, { useEffect } from "react";
import { FormattedMessage } from "react-intl";

import { PageProps, UpdateDomTitleForForm } from "@ezhou/core";
import { MainCard } from "@ezhou/app_mantis_1_1";
// ==============================|| Welcome PAGE ||============================== //

const WelcomePage = (pageProps: PageProps) => {
  useEffect(() => {
    UpdateDomTitleForForm(pageProps);
  });

  return (
    <MainCard title={pageProps.appUtil.getLocaleString("welcome")}>
      <div>
        <FormattedMessage id="welcomeToEzhou" />
      </div>
    </MainCard>
  );
};

export default WelcomePage;
